import { IPartnerFlags } from 'clickNgo/entities/partner/models/partnerFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import Logger from 'core/utils/Logger'

import { fetchPartnerFlagsByIdAndType } from './fetchPartnerFlagsByIdAndType'
import { fetchPartnerFlagsRequestsByIdAndType } from './fetchPartnerFlagsRequestsByIdAndType'

export const fetchPartnerFlagsById = async (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IPartnerFlags> => {
  const params = { partnerId }
  const cacheKey = partnerId
  try {
    const master = await fetchPartnerFlagsByIdAndType(params, { ...options, cacheKey })
    const request = await fetchPartnerFlagsRequestsByIdAndType(params, { ...options, cacheKey })
    const filteredMasterData = master.filter(
      (masterFlag) => !request.find((requestFlag) => requestFlag.code === masterFlag.code)
    )

    const flags = [...request, ...filteredMasterData]

    const accreditation = flags.filter(
      ({ codeType }) => codeType === ProfilingCodeType.Accreditation
    )
    const program = flags.filter(({ codeType }) => codeType === ProfilingCodeType.Program)
    const agreement = flags.filter(({ codeType }) => codeType === ProfilingCodeType.Agreement)

    return {
      accreditation,
      program,
      agreement,
    }
  } catch (err) {
    Logger.error(err)
    return {
      accreditation: [],
      program: [],
      agreement: [],
    }
  }
}
